import { render, staticRenderFns } from "./PrintLabelList.vue?vue&type=template&id=2b962cdf&"
import script from "./PrintLabelList.vue?vue&type=script&lang=js&"
export * from "./PrintLabelList.vue?vue&type=script&lang=js&"
import style0 from "./PrintLabelList.vue?vue&type=style&index=0&id=2b962cdf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports